import {SET_INSTRUMENT_TYPE_DRAGGING} from 'constants/action-types.js';
import {SET_PULLABLE_PART_DRAGGING} from 'constants/action-types.js';
import {SET_SHOW_FORMANT_EFFECT} from 'constants/action-types.js';
import {SET_SHOWING_FORMANTS} from 'constants/action-types.js';

const instrumentsReducer = (state = {}, action) => {
    let newState;
    switch (action.type) {
    case SET_PULLABLE_PART_DRAGGING:
        return {
            ... state,
            pullablePartDragging: action.payload
        };
    case SET_INSTRUMENT_TYPE_DRAGGING:
        return {
            ... state,
            instrumentTypeDragging: action.payload,
        };
    case SET_SHOWING_FORMANTS:
        return {
            ... state,
            showingFormants: action.payload
        };
    case SET_SHOW_FORMANT_EFFECT:
        return {
            ... state,
            showFormantEffect: action.payload
        };
    default:
        return state;
    }
};

export default instrumentsReducer;
